import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-email-preference-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './email-preference-card.component.html',
  styleUrl: './email-preference-card.component.scss',
})
export class EmailPreferenceCardComponent {
  title = input.required<string>();
  description = input.required<string>();
  checked = input<boolean>(false);
  controlName = input.required<string>();
  checkedChange = output<boolean>();

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const newValue = target.checked;
    this.checkedChange.emit(newValue);
  }
}
